import { lazy, Suspense, type ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import RootLayout from '@/layouts/RootLayout'
import NotFoundPage from '@/pages/NotFoundPage'
import LoadingSpinner from '@/components/ui/LoadingSpinner'

function wrap(factory: () => Promise<{ default: ComponentType }>) {
  const Component = lazy(factory)
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Component />
    </Suspense>
  )
}

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      {
        index: true,
        element: wrap(() => import('@/pages/HomePage')),
      },
      {
        path: 'verticals',
        element: wrap(() => import('@/pages/VerticalsPage')),
      },
      {
        path: 'verticals/commodity-markets',
        element: wrap(() => import('@/pages/CommodityMarketsPage')),
      },
      {
        path: 'verticals/:slug',
        element: wrap(() => import('@/pages/VerticalPage')),
      },
      {
        path: 'early-access',
        element: wrap(() => import('@/pages/EarlyAccessPage')),
      },
      {
        path: 'contact',
        element: wrap(() => import('@/pages/ContactPage')),
      },
      {
        path: 'blog',
        element: wrap(() => import('@/pages/BlogPage')),
      },
      {
        path: 'blog/satellite-signals-vs-survey-data',
        element: wrap(() => import('@/pages/BlogPostPage')),
      },
    ],
  },
]
